import { render, staticRenderFns } from "./mahjong.vue?vue&type=template&id=1a1ea9d3&scoped=true&"
import script from "./mahjong.vue?vue&type=script&lang=js&"
export * from "./mahjong.vue?vue&type=script&lang=js&"
import style0 from "./mahjong.vue?vue&type=style&index=0&id=1a1ea9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ea9d3",
  null
  
)

export default component.exports